import { StagedUser as StagedUserType } from '@/types';
import { supabase } from '@/integrations/supabase/client';

export class StagedUser {
  static async filter(criteria: any): Promise<StagedUserType[]> {
    let query = supabase.from('staged_users').select('*');
    
    // Apply any filter criteria
    if (criteria.district_id) {
      query = query.eq('district_id', criteria.district_id);
    }
    
    const { data, error } = await query;
    
    if (error) throw error;
    
    return (data || []) as StagedUserType[];
  }

  static async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('staged_users')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  }

  static async create(data: Partial<StagedUserType>): Promise<StagedUserType> {
    const { data: created, error } = await supabase
      .from('staged_users')
      .insert([{
        email: data.email || '',
        full_name: data.full_name || '',
        ...data
      }])
      .select()
      .single();
    
    if (error) throw error;
    
    return created as StagedUserType;
  }
}